import moment from 'moment'

export default (
  state = {
    items: [],
    totalizers: { isLoading: true, createdAt: '' },
    creditToExpire: { isLoading: true },
    campaign: { name: '', isLoading: true }
  },
  action
) => {
  switch (action.type) {
    case 'FETCH_EXTRACT_TOTALIZERS':
      return { ...state, totalizers: { isLoading: true } }
    case 'FETCH_EXTRACT_TOTALIZERS_SUCCESS':
      const { data } = action.payload
      const createdAt = moment.utc(data.insertDate).format('DD/MM/YYYY')
      const totalizers = {
        isLoading: false,
        onHold: data.lockedBalance,
        expired: data.expiredBalance,
        redeemed: data.redeemBalance,
        credited: data.creditBalance
      }
      return { ...state, totalizers, createdAt }
    case 'FETCH_EXTRACT_TOTALIZERS_FAIL':
      return {
        ...state,
        totalizers: { isLoading: false, error: action.error.data }
      }
    case 'FETCH_CREDIT_TO_EXPIRE':
      return { ...state, creditToExpire: { isLoading: true } }
    case 'FETCH_CREDIT_TO_EXPIRE_SUCCESS':
      return {
        ...state,
        creditToExpire: { items: action.payload.data, isLoading: false }
      }
    case 'FETCH_CREDIT_TO_EXPIRE_FAIL':
      return {
        ...state,
        creditToExpire: { isLoading: false, error: action.error.data }
      }
    case 'FETCH_EXTRACT':
      return { ...state, isLoading: true }
    case 'FETCH_EXTRACT_SUCCESS':
      return {
        ...state,
        items: action.payload.data,
        isLoading: false
      }
    case 'FETCH_EXTRACT_FAIL':
      return {
        ...state,
        isLoading: false,
        error: action.error.data
      }
    case 'FETCH_CAMPAIGN_NAME':
      return { ...state, isLoading: true }
    case 'FETCH_CAMPAIGN_NAME_SUCCESS':
      return {
        ...state,
        campaign: {
          name: action.payload.data.loyaltyBalanceCampaign[0].campaignName,
          isLoading: false
        }
      }
    case 'FETCH_CAMPAIGN_NAME_FAIL':
      return {
        ...state,
        campaign: { isLoading: false }
      }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/Participant/Extract/reducer.js